import React from 'react';
import { MachhaCharacter } from '../../lib/machhaAsset';
import styles from './ErrorBoundary.module.css';

interface Props { children: React.ReactNode; }
interface State { hasError: boolean; error: Error | null; }

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles['container']}>
          {/* Outer wrapper is relative so character can be positioned against it */}
          <div className={styles['outer-wrapper']}>

            {/* Character peeks over the right edge of the card — rotated inward */}
            <div className={styles['character-wrapper']}>
              <MachhaCharacter state="Error" size={160} />
            </div>

            {/* Card */}
            <div className={styles['card']}>
              <div className={styles['card-highlight']} />
              <h1 className={styles['title']}>Something went wrong</h1>
              <p className={styles['message']}>
                {/Failed to fetch dynamically imported module|Importing a module script failed|ChunkLoadError/i.test(this.state.error?.message ?? '')
                  ? 'This page could not load. Check your connection, then reload to get the latest version.'
                  : this.state.error?.message}
              </p>
              <button
                className={styles['reload-button']}
                onClick={() => window.location.reload()}
              >
                Reload page
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
